import { createClient } from '@sanity/client'

export const sanityClient = createClient({
  projectId: 'ggd6wkh6',
  dataset: 'production',
  apiVersion: '2025-11-23',
  useCdn: true,
})
